import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { DocumentEnquiryConstant } from "presentation/constant/DocumentEnquiry/DocumentEnquiryConstant";
import { useDocumentPreviewVM } from "presentation/hook/DocumentPreview/useDocumentPreviewVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { DialogModal, FieldType, HPHButton, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";

const DocumentPreviewFirstPrintModal: React.FC = () => {
    const [documentPreviewState] = useDocumentPreviewTracked();
    const documentPreviewVM = useDocumentPreviewVM();

    const { searchStatus, selectedRows, docFirstPrintCriteria, isShowPrintPad, dynamicOptions, searchCriteria } = documentPreviewState;

    const MODAL_CONST = DocumentEnquiryConstant.Modal;
    const messageBarVM = useMessageBarVM();
    const { printQueueDropdownOptions, fileLocationDropdownOptions } = dynamicOptions;
    const [anaInfoState] = useANAInfoTracked();
    const { userName } = anaInfoState;
    const { operatingUnit } = anaInfoState;
    const allowUpdateSL = isPermissionExist(Permission.DOCUMENT_PREVIEW_SL, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);
    const allowUpdateCC = isPermissionExist(Permission.DOCUMENT_PREVIEW_CC, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);

    const onPrintAndSentClicked = () => {
        const firstPrintIds = selectedRows.map(dtl => dtl.id) as number[];
        documentPreviewVM.onPrintAndSent(userName, firstPrintIds, selectedRows, docFirstPrintCriteria, searchCriteria, searchStatus,
            operatingUnit, allowUpdateSL, allowUpdateCC
        ).then((result) => {

            if (result && result["finalizeDocSucess"]) {
                messageBarVM.showSuccess(result["finalizeDocSucess"]?.toString());
            } else if (result && result["finalizeDocFail"]) {
                messageBarVM.showError(result["finalizeDocFail"]?.toString());
            }
        }).catch(() => {

        });
    }

    const memoFinalizedBy = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={docFirstPrintCriteria?.finalizedBy ?? ""}
                fieldValue={docFirstPrintCriteria?.finalizedBy}
                fieldLabel={""}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'finalizedBy'}
                maxLength={60}
                options={documentPreviewState.dynamicOptions.finalizedByDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentPreviewVM.onModalFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [docFirstPrintCriteria.finalizedBy, documentPreviewState.dynamicOptions.finalizedByDropdownOptions, documentPreviewVM])

    const memoInvPrinter = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={docFirstPrintCriteria?.invPrinter ?? ""}
                fieldValue={docFirstPrintCriteria?.invPrinter}
                fieldLabel={""}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'invPrinter'}
                maxLength={60}
                options={printQueueDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentPreviewVM.onModalFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [docFirstPrintCriteria.invPrinter, documentPreviewVM, printQueueDropdownOptions])

    const memoInvFileLoc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={docFirstPrintCriteria?.invFileLoc ?? ""}
                fieldValue={docFirstPrintCriteria?.invFileLoc}
                fieldLabel={""}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'invFileLoc'}
                maxLength={60}
                options={fileLocationDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentPreviewVM.onModalFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [docFirstPrintCriteria.invFileLoc, documentPreviewVM, fileLocationDropdownOptions])

    const memoSuppDocPrinter = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={docFirstPrintCriteria?.suppPrinter ?? ""}
                fieldValue={docFirstPrintCriteria?.suppPrinter}
                fieldLabel={""}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'suppPrinter'}
                maxLength={60}
                options={printQueueDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentPreviewVM.onModalFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [docFirstPrintCriteria.suppPrinter, documentPreviewVM, printQueueDropdownOptions])

    const memoSuppDocFileLoc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={docFirstPrintCriteria?.suppFileLoc ?? ""}
                fieldValue={docFirstPrintCriteria?.suppFileLoc}
                fieldLabel={""}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'suppFileLoc'}
                maxLength={60}
                options={fileLocationDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentPreviewVM.onModalFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [docFirstPrintCriteria.suppFileLoc, documentPreviewVM, fileLocationDropdownOptions])

    return <><DialogModal style={{ minWidth: '650px', minHeight: '650px' }}
        appendTo='self'
        showButton={false}
        visible={isShowPrintPad}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">DOCUMENTS TO PRINT</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={documentPreviewVM.cancelConfirmModal} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className="im-charge-data-search-confirm-modal-content">

                <CriteriaItemContainer>
                    <span className="DocPrintLabel">{'Finalized By'}</span>
                    {memoFinalizedBy}
                </CriteriaItemContainer>

                <CriteriaItemContainer>
                    <span className="DocPrintLabel">{MODAL_CONST.PRINTER}</span>
                </CriteriaItemContainer>

                <CriteriaItemContainer>
                    <span className="DocPrintLabel">{MODAL_CONST.PRINTER_INV}</span>
                    {memoInvPrinter}{memoInvFileLoc}
                </CriteriaItemContainer>

                <CriteriaItemContainer>
                    <span className="DocPrintLabel">{MODAL_CONST.PRINTER_SUPP}</span>
                    {memoSuppDocPrinter}{memoSuppDocFileLoc}
                </CriteriaItemContainer>

            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                {/* <HPHButton label={'View'} size={'Small'} theme={'Secondary'} onClick={onViewClicked}/> */}
                <HPHButton label={'Print/Sent'} size={'Small'} theme={'Primary'} onClick={onPrintAndSentClicked} />
            </div>
        }
    /></>;
};

export default memo(DocumentPreviewFirstPrintModal);